/**
 * Tour steps — Reports domain
 * Cubre: reports (clave), scheduled-reports, notifications, search
 */

import {
  FileText,
  Bell,
  MagnifyingGlass as Search,
  CalendarBlank
} from '@phosphor-icons/react';

// ============ REPORTS (clave en quick) ============
const reportsProspect = {
  id: 'reports',
  title: 'Informes para dirección, listos en 1 clic',
  description: 'Genera el informe ejecutivo del mes en PDF sin tocar Word. Datos en CSV/JSON cuando necesites cruzarlos con otros sistemas.',
  icon: FileText,
  position: 'right',
  highlight: '[data-testid="nav-reports"]',
  fallbackSelector: '[href="/reports"]',
  mode: 'prospect',
  length: 'both',
  domain: 'reports',
  videoFallback: null
};

const reportsOnboarding = {
  id: 'reports',
  title: 'Reports',
  description: 'Generación de reportes ejecutivos PDF con plantillas (Compliance, Posture, Incident summary). Export CSV/JSON para integración con BI o auditorías técnicas externas.',
  icon: FileText,
  position: 'right',
  highlight: '[data-testid="nav-reports"]',
  fallbackSelector: '[href="/reports"]',
  mode: 'onboarding',
  length: 'both',
  domain: 'reports',
  videoFallback: null
};

// ============ SCHEDULED REPORTS (solo full) ============
const scheduledReportsProspect = {
  id: 'scheduled-reports',
  title: 'Informes en automático',
  description: 'Programa el informe ejecutivo para que llegue al buzón de dirección cada lunes. Te olvidas de generarlo manualmente, ahorras horas al mes.',
  icon: CalendarBlank,
  position: 'right',
  highlight: '[data-testid="nav-scheduled-reports"]',
  fallbackSelector: '[href="/scheduled-reports"]',
  mode: 'prospect',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

const scheduledReportsOnboarding = {
  id: 'scheduled-reports',
  title: 'Scheduled Reports',
  description: 'Programación cron de reportes con destinatarios por email, plantilla y formato. Útil para entregables recurrentes a clientes MSSP o steering committees internos.',
  icon: CalendarBlank,
  position: 'right',
  highlight: '[data-testid="nav-scheduled-reports"]',
  fallbackSelector: '[href="/scheduled-reports"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

// ============ NOTIFICATIONS (solo full) ============
const notificationsProspect = {
  id: 'notifications',
  title: 'Avisos en tiempo real',
  description: 'Vektor te avisa al instante de alertas críticas, equipos caídos o escaneos terminados. Sin abrir 5 pestañas para enterarte.',
  icon: Bell,
  position: 'bottom-left',
  highlight: '[data-testid="notification-center"]',
  fallbackSelector: 'button:has(.lucide-bell)',
  mode: 'prospect',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

const notificationsOnboarding = {
  id: 'notifications',
  title: 'Notification Center',
  description: 'Bell topbar con alertas en tiempo real: críticas correlacionadas, agentes offline, scans completados, drift de compliance. Configurable por severidad y canal.',
  icon: Bell,
  position: 'bottom-left',
  highlight: '[data-testid="notification-center"]',
  fallbackSelector: 'button:has(.lucide-bell)',
  mode: 'onboarding',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

// ============ SEARCH (solo full) ============
const searchProspect = {
  id: 'search',
  title: 'Encuentra cualquier cosa en segundos',
  description: 'Pulsa Ctrl+K y escribe lo que buscas. Equipos, alertas, configuración. Más rápido que el menú.',
  icon: Search,
  position: 'bottom',
  highlight: 'button:has(.lucide-search)',
  fallbackSelector: null,
  mode: 'prospect',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

const searchOnboarding = {
  id: 'search',
  title: 'Command palette (Ctrl+K)',
  description: 'Paleta de comandos para navegación rápida y acciones globales. Acepta texto libre y fuzzy match sobre rutas, agents, vulns, alerts y settings.',
  icon: Search,
  position: 'bottom',
  highlight: 'button:has(.lucide-search)',
  fallbackSelector: null,
  mode: 'onboarding',
  length: 'full',
  domain: 'reports',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [reportsProspect],
    full: [reportsProspect, scheduledReportsProspect, notificationsProspect, searchProspect]
  },
  onboarding: {
    quick: [reportsOnboarding],
    full: [reportsOnboarding, scheduledReportsOnboarding, notificationsOnboarding, searchOnboarding]
  }
};
